export default "__VITE_ASSET__3e17763a__"